module.exports = __webpack_public_path__ + "static/team-vertical-aaebab957edf5c2fc175bd41f2d15b57.jpg";